import store from '../store'
export const getGarPolzZakActual = () => {
  const gar_polz_zak = store.getters.calc.gar_polz_zaksVal;
  if (!gar_polz_zak) return "-";
  return store.getters.getGar_polz_zaks.filter(
    item => item.id === gar_polz_zak
  )[0];
};
